export default "__VITE_ASSET__DKUTOppd__";